/**
 * Cart Drawer Utility
 * Provides a simple event-based mechanism to open the cart drawer from anywhere
 */

const OPEN_CART_DRAWER_EVENT = 'open-cart-drawer'

export function openCartDrawer(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_CART_DRAWER_EVENT))
  }
}

export const CART_DRAWER_EVENT = OPEN_CART_DRAWER_EVENT
